import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-steinberg',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><title>Steinberg icon</title><path d="M19.4807 12.6291c.6422-.371.6422-1.0092 0-1.3792L14.711 8.4954c-.6422-.371-1.1952-.052-1.1952.6901v5.508c0 .741.553 1.0601 1.1952.69zm-7.4812-9.9036c5.1219 0 9.2745 4.1526 9.2745 9.2745s-4.1526 9.2745-9.2745 9.2745S2.726 17.122 2.726 12s4.1516-9.2745 9.2735-9.2745m0-2.7255C5.3834 0 .0005 5.3829.0005 12s5.3829 12 12 12 11.999-5.3829 11.999-12-5.3829-12-12-12z"/></svg>`,
    styles: []
})
export class SimpleIconsSteinbergComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#C90827';
    @Input() className: string = 'simple-icons-steinberg'
    constructor() {}
    ngOnInit(): void {}
}
